import { useAuth } from "../context/auth";
import { Navigate, Outlet } from "react-router";
import Loading from "../components/Loading";

export default function RevisaoRoutes() {
    const auth = useAuth();
    if(auth.loading) {
        return (
            <Loading />
        )
    }
    return auth.user.role === 'revisao' || auth.user.role === 'admin' ? <Outlet /> : <Navigate to="/" />
}